import {
  buyRoot,
  freemiumPath,
  maintenancePath,
  onboardingExperimentalRoot,
  onboardingRoot,
  onboardingSurvey,
  userAuthSetupPath,
} from 'Consts/Strings';

const paths = {
  maintenance: maintenancePath,
  buy: buyRoot,
  welcome: onboardingRoot,
  welcomeExperimental: onboardingExperimentalRoot,
  welcomeSurvey: onboardingSurvey,
  freemium: freemiumPath,
  userAuthSetup: userAuthSetupPath,
};

export default paths;
